import {
  subscribeToPlace,
  unsubscribeFromPlace,
} from "@/services/supabase-service";
import { CardPopProps } from "@/types/type";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { Image } from "expo-image";
import { router } from "expo-router";
import React, { useEffect, useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

const PlaceCard = ({ place, additionalStyling, style }: CardPopProps) => {
  const basicStyling =
    "bg-white p-3 rounded-2xl w-[340px] flex-row items-center";
  const styling = style ? style : basicStyling;
  const [isSubscribed, setSubscibed] = useState(false);

  const placeAddress = `${place.street}, ${place.city}`;

  const OnSubscribePress = () => {
    if (place.id) {
      if (isSubscribed) {
        unsubscribeFromPlace(place.id);
        setSubscibed(false);
        place.subscribed = false;
        console.log("Unsubscribed");
      } else {
        subscribeToPlace(place.id);
        place.subscribed = true;
        setSubscibed(true);
        console.log("Subscribed");
      }
    }
  };

  useEffect(() => {
    const Subscription = async () => {
      if (place.id) {
        setSubscibed(place.subscribed ?? false);
      }
    };

    Subscription();
  }, [place.id]);

  return (
    <View className={`${styling} ${additionalStyling}`}>
      <TouchableOpacity
        className="g-white p-4 rounded-lg shadow-none w-full items-center m-1"
        onPress={() => {
          router.push(`/place-details?id=${place.id}`);
        }}
      >
        <View className="relative w-full h-[100px] p-1">
          <Image
            source={
              place.cover_url
                ? place.cover_url
                : require("../assets/images/photo.svg")
            }
            style={styles.image}
            contentFit="contain"
            transition={1000}
            cachePolicy={"memory-disk"}
          />
        </View>

        <View className="flex-1 pl-3">
          <Text className="text-base font-semibold text-gray-900 mt-2">
            {place.title}
          </Text>
          <View className="flex-row items-center mt-2">
            <FontAwesome name="map-marker" size={16} color="black" />
            <Text className="text-gray-500 text-xs flex-1">{placeAddress}</Text>
          </View>
        </View>

        <View className="absolute top-0 right-0 p-3">
          <TouchableOpacity className="ml-auto" onPress={OnSubscribePress}>
            {isSubscribed ? (
              <FontAwesome name="bookmark" size={24} color="black" />
            ) : (
              <FontAwesome name="bookmark-o" size={24} color="black" />
            )}
          </TouchableOpacity>
        </View>
        <View className="absolute top-9 right-0 p-3">
          <TouchableOpacity
            onPress={() => {
              router.push(`/comments?id=${place.id}&type=place`);
            }}
          >
            <FontAwesome name="comment" size={24} color="black" />
            <Text> {place.comments_num}</Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    //backgroundColor: '#fff',
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    width: "100%",
    fontSize: 100,
    alignItems: "center",
    justifyContent: "center",

    //backgroundColor: '#0553',
  },
});
export default PlaceCard;
